import isNumber from 'lodash/isNumber';
import React, { useCallback, useEffect, useState } from 'react';
import ReactDOM from 'react-dom';

import { SpacingAir } from 'craft/components/Spacing/SpacingAir/SpacingAir';
import { CssSelectorId } from 'craft/types';
import { getDomNodeFromDocument } from 'craft/utils/viewport';

export type Spacing = {
  marginTop: string;
  marginRight: string;
  marginBottom: string;
  marginLeft: string;
  paddingTop: string;
  paddingRight: string;
  paddingBottom: string;
  paddingLeft: string;
};

interface Props {
  cssProperties: any;
  nodeIds: string[];
  cssSelectorId?: CssSelectorId;
}

export const SpacingAirHandler = React.memo(({ cssProperties, nodeIds, cssSelectorId }: Props) => {
  const [counter, setCounter] = useState(0);

  const spacingAir = document.getElementById('spacing-air');

  // HACK!
  // We use a little trick to re-render the component here
  // unfortunately, the DOMchanges apply after the react css properties,
  // and this is the fastest way to re-render.
  // using MutationObservers causes more performance degradation, so we use
  // this hack while we find a better solution.
  useEffect(() => {
    setTimeout(() => setCounter(counter + 1), 15);
  }, [cssProperties]);

  const getSpacingValue = useCallback(
    (property: string): string =>
      isNumber(cssProperties[property])
        ? `${cssProperties[property]}px`
        : cssProperties[property] || '0px',
    [cssProperties],
  );

  if (!spacingAir) {
    return null;
  }

  const marginTop = getSpacingValue('marginTop');
  const marginRight = getSpacingValue('marginRight');
  const marginBottom = getSpacingValue('marginBottom');
  const marginLeft = getSpacingValue('marginLeft');

  const paddingTop = getSpacingValue('paddingTop');
  const paddingRight = getSpacingValue('paddingRight');
  const paddingBottom = getSpacingValue('paddingBottom');
  const paddingLeft = getSpacingValue('paddingLeft');

  const spacing = {
    marginLeft,
    marginTop,
    marginRight,
    marginBottom,
    paddingLeft,
    paddingTop,
    paddingRight,
    paddingBottom,
  };

  const airs = nodeIds.map((nodeId: string) => {
    const dom = getDomNodeFromDocument(nodeId, undefined, cssSelectorId);
    if (!dom) {
      return null;
    }
    return <SpacingAir key={`spacing-air-${nodeId}`} nodeId={nodeId} spacing={spacing} dom={dom} />;
  });
  return ReactDOM.createPortal(<>{airs}</>, spacingAir);
});
